import React, { useState, Fragment } from 'react';
import {
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Collapse,
  Card,
  CardBody,
  CardTitle,
  Input,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  faCommentDots,
  faEdit,
  faTrashAlt,
  faLaptopCode,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function MessageResponse({
  dialogUpdate,
  elem,
  dialogIndex,
  codeIndex,
  message,
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [messageInput, setMessageInput] = useState(message);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [postData, setPostData] = useState(elem);
  const handleEdit = () => {
    setIsEditing(true);
  };
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const handleDelete = () => {
    const data = { ...postData };
    data.messages.splice(codeIndex, 1);
    dialogUpdate(postData, dialogIndex);
    toggle();
  };
  const handleTextChange = (e) => {
    setMessageInput(e.target.value);
    const data = { ...postData };
    data.messages[codeIndex] = e.target.value;
    setPostData(data);
  };
  const handleSave = () => {
    dialogUpdate(postData, dialogIndex);
    setIsEditing(false);
  };
  const handleCancel = () => {
    setIsEditing(false);
    const data = { ...postData };
    data.messages[codeIndex] = message;
    setPostData(data);
    setMessageInput(message);
  };
  return (
    <Card className="mb-2">
      <CardBody>
        {isEditing ? (
          <Fragment>
            {' '}
            <CardTitle>
              <Row>
                {/* <pre>{JSON.stringify(postData, null, 2)}</pre> */}
                <Colxx xxs="6">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Text
                </Colxx>
                <Colxx xxs="6">
                  <div className="float-right">
                    <Button
                      color="primary"
                      className="add-button"
                      size="xs"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                    <b> </b>
                    <Button
                      color="secondary"
                      className="add-button"
                      size="xs"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                  </div>
                </Colxx>
              </Row>{' '}
            </CardTitle>
            <Row>
              <Colxx xxs="12">
                <Input
                  type="text"
                  defaultValue={messageInput ? messageInput : ''}
                  onChange={handleTextChange}
                />
              </Colxx>
            </Row>
          </Fragment>
        ) : (
          <Fragment>
            <CardTitle>
              <Row>
                <Colxx xxs="8">
                  <FontAwesomeIcon icon={faCommentDots} />
                  <span> </span>
                  Text
                </Colxx>
                <Colxx xxs="4">
                  <div className="float-right">
                    <FontAwesomeIcon
                      icon={faEdit}
                      color="#90caf9"
                      cursor="pointer"
                      onClick={handleEdit}
                    />
                    <b> | </b>
                    <FontAwesomeIcon
                      icon={faTrashAlt}
                      style={{ color: 'var(--theme-color-1)' }}
                      cursor="pointer"
                      onClick={toggle}
                    />
                  </div>
                </Colxx>
              </Row>
            </CardTitle>
            <Row>
              <Colxx xxs="12">
                <p>{messageInput}</p>
              </Colxx>
            </Row>
            <Modal isOpen={deleteVisible} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                <span role="img" aria-label="warning">
                  ⚠️
                </span>
                This message will be deleted!
              </ModalHeader>
              <ModalBody>
                <Button color="danger" onClick={() => handleDelete()} size="xs">
                  Delete
                </Button>
                <Button
                  className="ml-2"
                  color="dark"
                  outline
                  size="xs"
                  onClick={toggle}
                >
                  Cancel
                </Button>
              </ModalBody>
            </Modal>
          </Fragment>
        )}
      </CardBody>{' '}
    </Card>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(MessageResponse));
